export default "__VITE_ASSET__CG3IAdy1__"